export default {"src":"/_next/static/media/Group-25849.fe74c9b7.svg","height":104,"width":104};